import { Outlet } from 'react-router-dom'

const RootMain = () => {
  return <Outlet />
}

export default RootMain
